export const menuItems = [
    {
        label: "FABRICS",
        dropdown: [
            { label: "Georgette", path: "collections/georgette-fabric" },
            {
                label: "Ikkat cotton", path: "collections/ikkat-cotton-fabric",
                subcategories: [
                    { label: "Japan Satin", path: "collections/japan-satin-fabric" },],
            },
            { label: "Twile delight", path: "collections/twile-delight-fabric" },
            { label: "Viscose", path: "collections/viscose-fabric" },
            { label: "Checked Cotton", path: "collections/checked-cotton-fabric" },
            { label: "Dupion Digital", path: "collections/dupion-digital-fabric" },
            { label: "Organza", path: "collections/organza-fabric" },
            { label: "Organza Printed", path: "collections/organza-printed-fabric" },   
            { label: "Organza Sequence", path: "collections/organza-sequence-fabric" },
            { label: "Brocade Shiny", path: "collections/brocade-shiny-fabric" },
            { label: "Banarasi Brocade", path: "collections/banarasi-brocade-fabric" },
            { label: "Brasso Net", path: "collections/brasso-net-fabric" },
            { label: "Embroidery Cotton", path: "collections/embroidery-cotton-fabric" },
            { label: "Embroidery Net", path: "collections/embroidery-net-fabric" },
            { label: "Shimmer Net", path: "collections/shimmer-net-fabric" },
            { label: "Plain Net", path: "collections/plain-net-fabric" },
            { label: "Georgette Floral Sequence", path: "collections/georgette-floral-sequence-fabric" },
            { label: "Kalamkari", path: "collections/kalamkari-fabric" },
            { label: "Lace Net", path: "collections/lace-net-fabric" },
            { label: "Lycra", path: "collections/lycra-fabric" },
            { label: "Plain Cotton", path: "collections/plain-cotton-fabric" },
            { label: "Plain Georgette", path: "collections/plain-georgette-fabric" },
            { label: "Printed Cotton", path: "collections/printed-cotton-fabric" },
            { label: "Printed Satin", path: "collections/printed-satin-fabric" },
            { label: "Silicon Georgette", path: "collections/silicon-georgette-fabric" },
            { label: "Viscose Organza", path: "collections/viscose-organza-fabric" },
            { label: "Satin Georgette", path: "collections/satin-georgette-fabric" },
            { label: "Chiffon", path: "collections/chiffon-fabric" }


            // { label: "New Arrivals", path: "collections/new-arrivals-fabrics" },
            // {
            //     label: "Printed Fabrics",
            //     subDropdown: [
            //         { label: "Japan Satin", path: "collections/japan-satin-fabric" },
            //         { label: "Mulmul", path: "collections/mulmul-fabric" },
            //         { label: "Crepe Silk", path: "collections/crepe-silk-fabric" },
            //         { label: "Art Silk", path: "collections/art-silk-fabric" },
            //         { label: "Glazed Cotton", path: "collections/glazed-cotton-fabric" },
            //         { label: "Cotton Cambric", path: "collections/cambric-cotton-fabric" },
            //         { label: "Kota Doria", path: "collections/kota-doria-fabric" },
            //         { label: "Bemberg Chiffon", path: "collections/bemberg-chiffon-fabric" },
            //         { label: "Gaji Silk", path: "collections/gaji-silk-fabric" },
            //         { label: "Pure Linen", path: "collections/pure-linen-fabric" },
            //         { label: "Georgette", path: "collections/georgette-fabric" },
            //         { label: "Georgette Satin", path: "collections/georgette-satin-fabric" },
            //         { label: "Viscose Georgette", path: "collections/viscose-georgette-fabric" },
            //         { label: "Moss Georgette", path: "collections/moss-georgette-fabric" },
            //         { label: "Poly Cambric", path: "collections/poly-cambric-fabric" },
            //         { label: "Pashmina", path: "collections/pashmina-fabric" },
            //         { label: "Natural Crepe", path: "collections/natural-crepe-fabric" },
            //         { label: "Chiffon Satin", path: "collections/chiffon-satin-fabric" },
            //         { label: "Imported Satin", path: "collections/imported-satin-fabric" },
            //         { label: "Lush Satin", path: "collections/lush-satin-fabric" },
            //         { label: "Charmeuse Satin", path: "collections/charmeuse-satin-fabric" },
            //         { label: "Viscose Muslin", path: "collections/viscose-muslin-fabric" },
            //         { label: "Muslin", path: "collections/muslin-fabric" },
            //         { label: "Velvet", path: "collections/velvet-fabric" },
            //         { label: "Velvet 58", path: "collections/velvet-58-fabric" },
            //         { label: "Pure Organza", path: "collections/pure-organza-fabric" },
            //         { label: "Liquid Organza", path: "collections/liquid-organza-fabric" }
            //     ],
            // },
            // {
            //     label: "Plain/Dyed Fabrics",

            //     subDropdown: [
            //         { label: "Cotton Flex", path: "collections/cotton-flex-fabric" },
            //         { label: "Blend Cotton Slub", path: "collections/blend-cotton-slub-fabric" },
            //         { label: "Glazed Cotton", path: "collections/glazed-cotton-plain-fabric-" },
            //         { label: "Cotton Cambric", path: "collections/cotton-cambric-fabric" },
            //         { label: "Viscose Modal Silk", path: "collections/viscose-modal-silk-fabric" },
            //         { label: "Cotton Mulmul", path: "collections/cotton-mulmul-fabric" },
            //         { label: "Pure Natural Crepe", path: "collections/pure-natural-crepe-fabric" },
            //         { label: "Pure Organza", path: "collections/pure-organza-plain-fabric" },
            //         { label: "Imported Satin", path: "collections/imported-satin-plain-fabric" },
            //         { label: "Pure Georgette", path: "collections/pure-georgette-fabric" },
            //         { label: "Moss Georgette", path: "collections/moss-georgette-plain-fabric" },
            //         { label: "Georgette", path: "collections/georgette-plain-fabric" },
            //         { label: "Japan Satin", path: "collections/japan-satin-plain-fabric" },
            //         { label: "Chiffon Satin", path: "collections/chiffon-satin-plain-fabric" },
            //         { label: "Pure Dola Silk", path: "collections/pure-dola-silk-fabric" },
            //         { label: "Liquid Organza", path: "collections/liquid-organza-plain-fabric" },
            //         { label: "Butter Crepe", path: "collections/butter-crepe-fabric" },
            //         { label: "Ultra Satin", path: "collections/ultra-satin-fabric" },
            //         { label: "Muslin", path: "collections/muslin-plain-fabric" },
            //         { label: "Kota Doria", path: "collections/kota-doria-plain-fabric" },
            //         { label: "Net", path: "collections/net-fabric" },
            //         { label: "Chinnon Chiffon", path: "collections/chinnon-chiffon-fabric" },
            //         { label: "Banana Crepe", path: "collections/banana-crepe-fabric" },
            //         { label: "Suede", path: "collections/suede-fabric" },
            //         { label: "Habutai Silk", path: "collections/habutai-silk-fabric" },
            //         { label: "Cotton Lycra", path: "collections/cotton-lycra-fabric" },
            //         { label: "Semi Scuba", path: "collections/semi-scuba-fabric" },
            //         { label: "Mashru Silk", path: "collections/mashru-silk-fabric" },
            //         { label: "Stretch Cotton", path: "collections/stretch-cotton-fabric" },
            //         { label: "Crepe", path: "collections/crepe-fabric" },
            //         { label: "Neon", path: "collections/neon-plain-fabric" },
            //         { label: "Velvet", path: "collections/velvet-plain-fabric" },
            //         { label: "Cotton", path: "collections/cotton-plain-fabric" },
            //         { label: "Pin-Tucks", path: "collections/pin-tucks-plain-fabric" },
            //         { label: "Chanderi", path: "collections/chanderi-fabric" },
            //         { label: "Rayon", path: "collections/rayon-fabric" },
            //         { label: "Plain Lycra", path: "collections/plain-lycra-fabric" }
            //     ],
            // },
            // {
            //     label: "Design and Pattern",

            //     subDropdown: [
            //         { label: "Animal", path: "collections/animal-fabric" },
            //         { label: "Checks", path: "collections/checks-fabric" },
            //         { label: "Chevron", path: "collections/chevron-fabric" },
            //         { label: "Christmas", path: "collections/christmas-fabric" },
            //         { label: "Leaf", path: "collections/leaf-fabric" },
            //         { label: "Leheriya", path: "collections/leheriya-fabric" },
            //         { label: "Mix N Match", path: "collections/mix-n-match-fabric" },
            //         { label: "Mughal Print", path: "collections/mughal-print-fabric" },
            //         { label: "Quirky", path: "collections/quirky-fabric" },
            //         { label: "Paisley", path: "collections/paisley-fabric" },
            //         { label: "Patola", path: "collections/patola-fabric" },
            //         { label: "Polka Dots", path: "collections/polka-dots-fabric" },
            //         { label: "Trellis", path: "collections/trellis-fabric" },
            //         { label: "Stripes", path: "collections/stripes-fabric" },
            //         { label: "Floral", path: "collections/floral-design-fabric" },
            //         { label: "Ethnic", path: "collections/ethnic-fabric" },
            //         { label: "Valentine's", path: "collections/-fabric" },
            //         { label: "Geometric", path: "collections/valentines-fabric" },
            //         { label: "Abstract", path: "collections/abstract-fabric" },
            //         { label: "Traditional", path: "collections/traditional-fabric" },
            //         { label: "Tricolor", path: "collections/tricolor-fabric" },
            //         { label: "Tie & Dye", path: "collections/tie-n-dye-fabric" },
            //         { label: "Kids Print", path: "collections/kids-print-fabric" },
            //         { label: "Gamthi", path: "collections/gamthi-fabric" },
            //         { label: "Illusion", path: "collections/illusion-fabric" },
            //         { label: "Booti", path: "collections/booti-fabric" },
            //         { label: "Feather", path: "collections/feather-fabric" },
            //         { label: "Halloween", path: "collections/halloween-fabric" },
            //         { label: "Chain", path: "collections/chain-fabric" },
            //         { label: "Madhubani & Pichwaii", path: "collections/madhubani-n-pichwaii-fabric" },
            //         { label: "Denim", path: "collections/denim-fabric" },
            //         { label: "Tropical", path: "collections/tropical-fabric" },
            //         { label: "Rainbow", path: "collections/rainbow-fabric" },
            //         { label: "Marble", path: "collections/marble-fabric" },
            //         { label: "Map", path: "collections/map-design-fabric" },
            //         { label: "Newspaper", path: "collections/newspaper-fabric" },
            //         { label: "Social Media", path: "collections/social-media-fabric" },
            //         { label: "Camouflage", path: "collections/camouflage-fabric" },
            //         { label: "Egyptian", path: "collections/egyptian-fabric" },
            //         { label: "Ombre", path: "collections/ombre-fabric" },
            //         { label: "Bistro", path: "collections/bistro-fabric" },
            //         { label: "Butterfly", path: "collections/butterfly-fabric" },
            //         { label: "Heart", path: "collections/heart-fabric" },
            //         { label: "Bird", path: "collections/bird-fabric" },
            //         { label: "Patch", path: "collections/patch-fabric" },
            //         { label: "Texture", path: "collections/texture-fabric" },
            //         { label: "Bandhani", path: "collections/bandhani-fabric" },
            //         { label: "Pin-Tucks", path: "collections/pin-tucks-design-fabric" },
            //     ],
            // },
            // {
            //     label: "Indian Crafts",

            //     subDropdown: [
            //         { label: "Ajrakh", path: "collections/ajrakh-fabric" },
            //         { label: "Banarasi", path: "collections/banarasi-fabric" },
            //         { label: "Dabu", path: "collections/dabu-fabric" },
            //         { label: "Handloom", path: "collections/handloom-fabric" },
            //         { label: "Ikatw", path: "collections/ikatw-fabric" },
            //         { label: "Indigo", path: "collections/indigo-fabric" },
            //         { label: "Kalamkari", path: "collections/kalamkari-fabric" },
            //         { label: "Kashish", path: "collections/kashish-fabric" },
            //         { label: "Monochrome", path: "collections/monochrome-fabric" },
            //         { label: "Batik", path: "collections/batik-fabric" },
            //         { label: "Shibori", path: "collections/shibori-fabric" },
            //         { label: "Kantha", path: "collections/kantha-fabric" },
            //         { label: "Bagh Print", path: "collections/bagh-print-fabric" }
            //     ],
            // },
            // {
            //     label: "Work and Embroidery",

            //     subDropdown: [
            //         { label: "Premium Embroidery Fabric", path: "collections/premium-emboridery-fabric" },
            //         { label: "Premium Sequins Georgette", path: "collections/premium-sequins-georgette-fabric" },
            //         { label: "Velvet Sequins Fabric", path: "collections/velvet-sequins-fabric" },
            //         { label: "Position Print", path: "collections/position-print-fabric" },
            //         { label: "Sequins Fabric", path: "collections/sequins-fabric" },
            //         { label: "Swarovski", path: "collections/swarovski-fabric" },
            //         { label: "Bemberg Crepe Lurex", path: "collections/bemberg-crepe-lurex-fabric" },
            //         { label: "Printed Embroidery Fabric", path: "collections/printed-embroidery-fabric" },
            //         { label: "Printed Sequins Fabric", path: "collections/printed-sequins-fabric" },
            //         { label: "Lucknowi Fabric", path: "collections/lucknowi-fabric" },
            //         { label: "Foil Print Fabric", path: "collections/foil-print-fabric" },
            //         { label: "Dyeable Embroidery Fabric", path: "collections/dyeable-embroidery-fabric" },
            //         { label: "Handblock Sequins Fabric", path: "collections/handblock-sequins-fabric" },
            //         { label: "Sequins Georgette Fabric", path: "collections/sequins-georgette-fabric" },
            //         { label: "Schiffli Embroidery Fabric", path: "collections/schiffli-embroidery-fabric" },
            //         { label: "Texture Sequins Fabric", path: "collections/texture-sequin-fabric" },
            //         { label: "Handblock Embroidery Fabric", path: "collections/handblock-embroidery-fabric" },
            //         { label: "Mirror Embroidery Printed Fabric", path: "collections/mirror-embroidery-printed-fabric" },
            //         { label: "Sequins Crepe Fabric", path: "collections/sequins-crepe-fabric" },
            //     ],
            // },
            // {
            //     label: "Pleated Fabric",
            //     subDropdown: [
            //         { label: "Printed Pleated Fabric", path: "collections/printed-pleated-fabric" },
            //         { label: "Plain Pleated Fabric", path: "collections/plain-pleated-fabric" },
            //     ],
            // },
            // { label: "Dyealble Fabric", path: "collections/dyealble-fabric" },
            // {
            //     label: "Organic Fabric",
            //     subDropdown: [
            //         { label: "Eucalyptus", path: "collections/eucalyptus-fabric" },
            //         { label: "Orange", path: "collections/orange-fabric" },
            //         { label: "Milk", path: "collections/milk-fabric" },
            //         { label: "Corn", path: "collections/corn-fabric" }
            //     ],
            // },
            // {
            //     label: "Rangmanch",
            //     subDropdown: [
            //         { label: "Yellow", path: "collections/yellow-fabric" },
            //         { label: "Red", path: "collections/red-fabric" },
            //         { label: "Black", path: "collections/black-fabric" },
            //         { label: "Blue", path: "collections/blue-fabric" },
            //         { label: "Peach", path: "collections/peach-fabric" },
            //         { label: "Mellow Yellow", path: "collections/mellow-yellow-fabric" },
            //         { label: "Sky Blue", path: "collections/sky-blue-fabric" },
            //         { label: "Salmon Pink", path: "collections/salmon-pink-fabric" },
            //         { label: "Lime Green", path: "collections/lime-green-fabric" },
            //         { label: "Hickory Brown", path: "collections/-hickory-brown-fabric" },
            //         { label: "Peacock Blue", path: "collections/peacock-blue-fabric" },
            //         { label: "Bottle Green", path: "collections/bottle-green-fabric" },
            //     ],
            // },
            // { label: "Imported Fabrics", path: "collections/imported-fabrics" },
            // {
            //     label: "Furnishing",

            //     subDropdown: [
            //         { label: "Certain Febric", path: "collections/certain-fabric" },
            //         { label: "Sheer Febric", path: "collections/sheer-fabric" },
            //         { label: "Shofa Febric", path: "collections/shofa-fabric" },
            //         { label: "Coshion Cover", path: "collections/coshion-cover-fabric" },
            //     ],
            // },
            // { label: "Customer Choice", path: "collections/customer-choice-fabric" },
            // { label: "Fabric Book", path: "collections/fabric-book" },
        ],
    },
    {
        label: "SAREES",
        dropdown: [
            { label: "Designer Saree", path: "collections/designer-sarees" },
      { label: "Dupion Saree", path: "collections/dupion-sarees" },
      { label: "Tissue Zardozi Saree", path: "collections/tissue-zardozi-sarees" },
      { label: "Ikkath Pochamali Saree", path: "collections/ikkath-pochamali-sarees" },
      { label: "Ikkath Saree", path: "collections/ikkath-sarees" },
      { label: "Kota Silk Cotton Saree", path: "collections/kota-silk-cotton-sarees" },
      { label: "Banarasi silk Saree", path: "collections/banarasi-silk-sarees" },
      { label: "Raw Mango Silk Saree", path: "collections/raw-mango-silk-sarees" },
      { label: "Orange Floral Saree", path: "collections/orange-floral-sarees" },
      { label: "Tissue Banarsi Saree", path: "collections/tissue-banarsi-sarees" },
      { label: "Tissue Antique Saree", path: "collections/tissue-antique-sarees" },
      { label: "Tussar Meenakari Saree", path: "collections/tussar-meenakari-sarees" },
      { label: "Kora Antique Saree", path: "collections/kora-antique-sarees" },
      { label: "Kora Designer Saree", path: "collections/kora-designer-sarees" },
      { label: "Dupion Rankat Saree", path: "collections/dupion-rankat-sarees" },
      { label: "Banarszi Tissue Saree", path: "collections/banarszi-tissue-sarees" },
      { label: "Silk Cotton Saree", path: "collections/silk-cotton-sarees" },
      { label: "Pure Silk Saree", path: "collections/pure-silk-sarees" },
      { label: "Chandhiri Silk Saree", path: "collections/chandhiri-silk-sarees" },
      { label: "Cotton Saree", path: "collections/cotton-sarees" },
      { label: "Mulbery-Cotton Saree", path: "collections/mulbery-cotton-sarees" }
        ],
    },
    {
        label: "UNIQUE COSTUMES",
        dropdown: [
            { label: "Long Gown", path: "collections/long-gown" },
            { label: "Short Gown", path: "collections/short-gown" },
            {
                label: "Kurtis",
                subDropdown: [
                    { label: "Cotton Kurtis", path: "collections/cotton-kurtis" },
                    { label: "Synthetic Kurtis", path: "collections/synthetic-kurtis" },
                    { label: "A Line Kurtis", path: "collections/a-line-kurtis" },
                    { label: "Panel Kurtis", path: "collections/panel-kurtis" },
                    { label: "Umberalla Kurtis", path: "collections/umberalla-kurtis" },
                ],
            },
            { label: "Skirts", path: "collections/skirts" },
            { label: "Peplum Top", path: "collections/peplum-top" },
        ]
    },
    {
        label: "CUSTOMIZED FABRICS", path: "collections/customized-fabrics"
    },
    {
        label: "AAVRYAAS EXCLUSIVE",
        path: "collections/aavryaas-exclusive-fabrics"
    },
    {
        label: "VINTAGE COLLECTION",
        path: "collections/vintage-collection"
    }
];
